<template>
  <div>
    <div class="game-header">
      <div v-if="isRoundInProgress">
        <localized-label>roundLabel</localized-label>
        <span class="round-number">{{round.displayId }}</span>
        <localized-label>roundInProgressLabel</localized-label>
      </div>
      <div v-else>
        <localized-label>roundLabel</localized-label>
        <span class="round-number">{{round.displayId}}</span>
        <localized-label>roundStartingInLabel</localized-label>
        <seconds-countdown class="round-starts-in"
                           :start="roundEventStart"
                           :duration="roundEventDuration">
        </seconds-countdown>
        <span v-if="isBettingDisabled">
          <localized-label>bettingDisabled</localized-label>
        </span>
      </div>
    </div>
    <div class="game-body">
      <label for="betId"
             class="input-label">
        <localized-label>betIdLabel</localized-label>
      </label>
      <input type="text"
             name="betId"
             maxlength="60"
             class="input-field"
             id="betInput"
             ref="inputBetId"
             :readonly="isBettingDisabled"
             :class="{disabled: isBettingDisabled}"
             @keypress="validateShortcutChar"
             @keydown="nonPrintableChar"
             @keydown.tab.enter.prevent="addBet()"
             v-model="inputBetId"
             autocomplete="off"
             @keyup.up="focusShortcuts('exit')"
             @keyup.down="focusShortcuts('enter')"
             @keyup.left="previousShortcut"
             @keyup.right="nextShortcut">

      <div class="input-error"
           v-if="inputError">
        {{inputErrorMessage}}
      </div>
      <ShopBetslip ref="inputPayment"
                   :items="ticketBets"
                   :total="ticket.payment.toFixed(paymentFormatValue)"
                   :disabled="isBettingDisabled"
                   :edit="editBet"
                   @editBet="addBetShortcut"
                   @editStake="editBetslipBetStake"
                   @input="updateBetslipBets"
                   @payin="payticket"
                   @remove="removeBet">
      </ShopBetslip>
    </div>
    <!-- <div class="shortcut-preview">
      <div v-for="(bet,index) in filteredList"
           :key="index">
        <span class="on-hover"
              @click="mouseSelectShortcut(index)"
              :class='{"active-item": currentShortcut === index}'
              v-if="isActiveShortcut(inputBetId)">
          {{bet}}
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  cloneDeep,
  defaultTo,
  each,
  isArray,
  isEmpty,
  isNaN,
  isNil,
  isNumber,
  last,
  lastIndexOf,
  range,
  round,
  set,
  sumBy,
  template,
  toNumber,
  toUpper,
  trim,
  trimEnd,
} from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import ShopBetslip from '@/components/ShopBetslip';
import { numerable } from '@/mixins';
import {
  getBetFromShortcut,
  formatBet,
  bus,
} from '@/utility';

export default {
  name: 'Shop',
  components: {
    ShopBetslip,
  },
  mixins: [
    numerable,
  ],
  data() {
    return {
      bestslipMultiEdit: true,
      betCounter: 0,
      betIndex: null,
      currentShortcut: -1,
      disabledInputBetId: false,
      editBet: false,
      paymentFormatValue: 2,
      inputBetId: null,
      inputError: false,
      inputErrorMessage: null,
      invalidShortcuts: null,
      isFocusShortcut: false,
      isMouseSelect: false,
      multiBetCounter: 0,
      savedPosition: 0,
      separatorCounter: [],
      ticketIsProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'allowedShortcutChars',
      'betShortcuts',
      'isBettingDisabled',
      'isRoundInProgress',
      'multiStraightSeparator',
      'round',
      'roundEventDuration',
      'roundEventStart',
      'ticket',
      'translations',
      'updateBet',
      'wheel',
      'wheelBets',
      'wheelTickets',
    ]),
    filteredList() {
      if (this.filterMultipleBets === '-' || this.filterMultipleBets === '') {
        return '';
      }
      if (this.filterMultipleBets !== null && this.isBettingDisabled === false && this.filterMultipleBets.match(/^\d/)) {
        // eslint-disable-next-line max-len
        return (this.betShortcuts.filter(bet => bet.toLowerCase().startsWith(this.filterMultipleBets.toLowerCase()))).slice(0, 9);
      } if (this.filterMultipleBets !== null && this.isBettingDisabled === false && !this.filterMultipleBets.match(/^\d/)) {
        // eslint-disable-next-line max-len
        return (this.betShortcuts.filter(bet => bet.toLowerCase().startsWith(this.filterMultipleBets.toLowerCase()))).slice(0, 12);
      }
      return '';
    },
    filterMultipleBets() {
      let inputAfterSeparator = '';
      if (this.inputBetId !== null) {
        const getIndex = lastIndexOf(this.inputBetId, this.multiStraightSeparator);
        inputAfterSeparator = this.inputBetId.slice(getIndex + 1);
      }
      return isNil(inputAfterSeparator) ? null : inputAfterSeparator;
    },
    ticketBets() {
      const bets = cloneDeep(this.ticket.bets);
      each(bets, (item) => {
        const bet = item;
        bet.payment = this.ticket.payment !== 0
          ? this.formatNumber(item.payment) : parseFloat(item.payment).toFixed(2);
        bet.displayValue = bet.displayValue.replace('-1', '00').replace(/,/g, ', ');
      });
      return bets;
    },
  },
  methods: {
    ...mapActions([
      'addTicketBet',
      'setAllowedShortcut',
      'updateBetslipTicket',
    ]),
    mouseSelectShortcut(index) {
      this.isMouseSelect = false;
      this.currentShortcut = index;
      this.$refs.inputBetId.focus();
      this.addBet();
      this.isFocusShortcut = false;
    },
    moveCursorToEnd() {
      const el = document.getElementById('betInput');
      el.focus();
      if (typeof el.selectionStart === 'number') {
        el.selectionStart = el.value.length;
        el.selectionEnd = el.value.length;
      } else if (typeof el.createRange !== 'undefined') {
        const reach = el.createRange();
        reach.collapse(false);
        reach.select();
      }
    },
    focusShortcuts(event) {
      this.moveCursorToEnd();
      if (event === 'enter') {
        if (this.isFocusShortcut === false) {
          this.isFocusShortcut = true;
          this.currentShortcut = this.savedPosition;
        } else {
          this.currentShortcut = 0;
        }
      } else if (event === 'exit') {
        this.isFocusShortcut = false;
        this.savedPosition = this.currentShortcut;
        this.currentShortcut = -1;
      }
    },
    isActiveShortcut(inputBet) {
      return !(isNil(inputBet) || isEmpty(inputBet));
    },
    previousShortcut() {
      if (this.currentShortcut > 0 && this.isFocusShortcut) {
        this.currentShortcut -= 1;
      }
    },
    nextShortcut() {
      // eslint-disable-next-line max-len
      if (this.currentShortcut < this.filteredList.length - 1 && this.currentShortcut < 11 && this.isFocusShortcut) {
        this.currentShortcut += 1;
      }
    },
    resetCounter() {
      // eslint-disable-next-line max-len
      if (isNil(this.inputBetId) || isEmpty(this.inputBetId) || this.currentShortcut > this.filteredList.length - 1 || this.isBettingDisabled === true) {
        this.currentShortcut = -1;
        this.savedPosition = 0;
        this.isMouseSelect = false;
      }
    },
    addBet() {
      this.disabledInputBetId = true;
      this.inputError = false;
      this.inputErrorMessage = null;
      this.separatorCounter = [];
      const bet = this.isValidInputBetId();


      if (this.currentShortcut > 0 && this.isMouseSelect === false) {
        const inputBetId = trimEnd(this.inputBetId, this.filterMultipleBets);
        this.inputBetId = inputBetId.concat(this.filteredList[this.currentShortcut]);
        this.currentShortcut = -1; // double check if shortcut picker fails
        this.resetCounter();
        this.isFocusShortcut = false;
        return false;
      }
      if (this.currentShortcut === 0) {
        if (this.inputBetId) {
          const inputBetId = trimEnd(this.inputBetId, this.filterMultipleBets);
          this.inputBetId = inputBetId.concat(this.filteredList[this.currentShortcut]);
        } else {
          this.inputBetId = this.filteredList[this.currentShortcut];
        }
        this.currentShortcut = -1;
        this.isFocusShortcut = false;
        return false;
      }
      if (bet) {
        if (!this.validatePreBetslip(bet)) {
          this.enableBetInput();
          this.inputError = true;
          return false;
        }

        if (isArray(bet)) {
          each(bet, (n) => {
            formatBet(n);
          });
        } else {
          formatBet(bet);
        }
        if (this.editBet) {
          this.editBetslipBet(bet);
        } else {
          this.addTicketBet(bet).then(() => {
            this.paymentFormatValue = 2;
            this.resetBet();
          });
        }
      } else if (this.inputBetId && this.inputBetId.length) {
        this.inputError = true;
        this.inputErrorMessage = this.translations.invalidBetShortcutError;
        if (!isNil(this.invalidShortcuts)) {
          this.inputErrorMessage = this.inputErrorMessage.concat(this.invalidShortcuts);
        }
      }

      return true;
    },
    enableBetInput() {
      this.disabledInputBetId = false;
      this.$nextTick(() => {
        const bettingInput = this.$refs.inputBetId;
        if (bettingInput) {
          bettingInput.focus();
        }
      });
    },
    isValidInputBetId() {
      if (this.inputBetId && this.inputBetId.length) {
        const betShortcut = toUpper(trim(this.inputBetId));
        const bet = getBetFromShortcut(betShortcut);
        if (!isNil(bet)) {
          this.multiBetCounter = bet.length;
        }
        return bet;
      }

      return false;
    },
    resetBet() {
      this.inputBetId = null;
      this.enableBetInput();
    },
    editBetslipBet(bet) {
      const ticket = cloneDeep(this.ticket);
      ticket.bets[this.betIndex] = bet;
      ticket.payment = this.sumBetslipBets(ticket.bets);
      this.updateBetslipTicket({ ticket, recalculateBetPayment: false }).then(() => {
        this.paymentFormatValue = 2;
        this.editBet = false;
        this.resetBet();
      });
    },
    editBetslipBetStake(value) {
      const betStake = toNumber(value.stake.replace(/,/g, ''));
      const betPayment = toNumber(this.ticket.bets[value.index].payment);
      if (betPayment !== betStake) {
        const ticket = cloneDeep(this.ticket);
        ticket.bets[value.index].payment = betStake.toFixed(this.getFixedNumber(value.stake));
        ticket.payment = this.sumBetslipBets(ticket.bets);
        this.paymentFormatValue = 2;
        this.updateBetslipTicket({ ticket, recalculateBetPayment: false });
      }
    },
    formatNumber(value) {
      return value.toString().replace(/,/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    getFixedNumber(value) {
      return value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0;
    },
    focusPaymentInput() {
      this.$nextTick(() => {
        const paymentInput = this.$refs.inputPayment.$refs.payment;
        if (paymentInput) {
          paymentInput.focus();
        }
      });
    },
    payticket() {
      if (this.ticket.bets.length && !this.ticketIsProcessing) {
        const ticket = cloneDeep(this.ticket);
        each(ticket.bets, (item) => {
          const bet = item;
          bet.payment = toNumber(bet.payment);
        });
        ticket.payin = ticket.payment;
        this.updateBetslipTicket({ ticket, recalculateBetPayment: false });
        bus.$emit('payTicket');
      }
      this.inputBetId = '';
      this.paymentFormatValue = 2;
      this.inputErrorMessage = null;
      this.enableBetInput();
    },
    removeBet(index) {
      const ticket = cloneDeep(this.ticket);
      ticket.bets.splice(index, 1);
      this.betCounter = ticket.bets.length;
      ticket.payment = this.sumBetslipBets(ticket.bets);
      this.updateBetslipTicket({ ticket, recalculateBetPayment: false }).then(() => {
        this.resetBet();
      });
    },
    sumBetslipBets(bets) {
      return sumBy(bets, item => toNumber(item.payment));
    },
    updateBetslipBets(value) {
      const totalStake = toNumber(value.replace(/,/g, ''));
      if (round(parseFloat(this.ticket.payment), 2) !== totalStake) {
        this.paymentFormatValue = this.getFixedNumber(value);
        const ticket = cloneDeep(this.ticket);
        const stake = totalStake / ticket.bets.length;

        each(ticket.bets, (item) => {
          const bet = item;
          bet.payment = round(stake, 2);
        });

        ticket.payment = totalStake;
        this.updateBetslipTicket({ ticket, recalculateBetPayment: true });
      }
    },
    addBetShortcut(index) {
      if (!isNumber(index)) {
        this.resetBet();
        this.editBet = false;
      } else {
        this.betIndex = index;
        this.editBet = true;
        const bet = this.ticket.bets[index];
        const betShortcut = bet.name === 'straight' ? bet.displayValue : this.wheelBets[bet.name].shortcut.name;
        this.inputBetId = betShortcut;
        this.bestslipMultiEdit = false;
        this.$refs.inputBetId.focus();
      }
    },
    setListeners() {
      bus.$on('ShortcutClicked', (shortcut) => {
        if (shortcut) {
          this.inputBetId = shortcut;
          this.enableBetInput();
        }
      });
      bus.$on('FocusBetInput', () => {
        this.enableBetInput();
      });
      bus.$on('ticketChange', (ticket) => {
        set(ticket, 'payment', round(ticket.payment, 2));
        this.onTicketChange(ticket);
      });
      bus.$on('ticketIsProcessing', () => {
        this.ticketIsProcessing = true;
      });
      bus.$on('ticketIsResolved', () => {
        this.ticketIsProcessing = false;
      });
    },
    onTicketChange(ticket) {
      this.paymentFormatValue = this.getFixedNumber(defaultTo(ticket.payment, ticket.payin));
      this.betCounter = ticket.bets.length;
    },
    validateNumberOfBets() {
      if (this.editBet) return false;
      if (this.updateBet === false && isNil(this.multiBetCounter)) {
        this.betCounter += 1;
      } else if (this.updateBet === false && !isNil(this.multiBetCounter)) {
        this.betCounter += this.multiBetCounter;
      }
      return this.betCounter;
    },
    validatePreBetslip(bet) {
      const config = this.wheelTickets;
      if ((bet && bet.length > config.maxBets) || this.validateNumberOfBets() > config.maxBets) {
        this.inputErrorMessage = template(this.translations.invalidBetCount)(config);
        // eslint-disable-next-line max-len
        if (this.updateBet === false && !isNaN(this.multiBetCounter) && !isNil(this.multiBetCounter)) {
          this.betCounter -= this.multiBetCounter;
        } else if (this.updateBet === false) {
          this.betCounter -= 1;
        }
        return false;
      }

      return true;
    },
    inputFieldToArray() {
      const inputBetSplitter = [];
      each(this.inputBetId, (value) => {
        inputBetSplitter.push(value);
      });
      return inputBetSplitter;
    },
    nonPrintableChar(e) {
      if (!this.bestslipMultiEdit && e.key === this.multiStraightSeparator) {
        e.preventDefault();
      }
      if (this.inputBetId !== '' && e.key !== this.multiStraightSeparator) {
        this.separatorCounter = this.inputFieldToArray();
        if (this.separatorCounter[0] === this.multiStraightSeparator) {
          this.separatorCounter.shift();
        } if (last(this.separatorCounter) === this.multiStraightSeparator) {
          this.separatorCounter.pop();
        }
      }
      if (this.inputBetId !== '' && e.key === this.multiStraightSeparator) {
        this.separatorCounter = this.inputFieldToArray();
      }
      if (!this.inputBetId && e.keyCode === 13) {
        this.focusPaymentInput();
      }
    },
    validateShortcutChar(e) {
      const key = toUpper(e.key);
      if (key && this.allowedShortcutChars.indexOf(key) < 0) {
        e.preventDefault();
      }
    },
  },
  created() {
    window.addEventListener('keyup', (e) => { if (e.keyCode === 107) this.enableBetInput(); });
  },
  mounted() {
    const numbers = range(0, 36);
    this.setAllowedShortcut(numbers);
    this.setListeners();
  },
  updated() {
    this.resetCounter();
  },
};
</script>

<style lang="scss">
  @import "@/assets/scss/general/main.scss";
  .game-header {
    height: 35px;
    padding-left: 45px;
    line-height: 35px;
    background-color: #3eb489;
    text-align: left;
    color: #fff;
    font-size: 0.9rem;
    span {
      margin-right: 5px;
    }
  }
  .game-header .round-number {
    font-weight: bold;
  }
  .disabled {
    background-color: #e0e0e0;
  }
  .game-header .round-starts-in {
    font-weight: bold;
  }

  .game-body {
    padding: 25px;
  }

  .active-item {
    background-color: #474747 !important;
    color: #dfdfdf !important;
  }

  .disabled {
    background-color: #e0e0e0;
  }
</style>
